/** Signed storage uses the existing opaque-response upload contract. Result persistence is separate. */
export const uploadExecutionFile = async (
  file: File,
  signed: { url: string; fields: Record<string, string> },
  signal: AbortSignal
) => {
  const body = new FormData()
  Object.keys(signed.fields).forEach((key) => body.append(key, signed.fields[key]))
  body.append('file', file)
  const response = await fetch(signed.url, { method: 'POST', body, mode: 'no-cors', signal })
  if (response.type !== 'opaque' && !response.ok) throw new Error('Upload failed')
}
